/* eslint-disable  @typescript-eslint/no-unused-vars */

import React,{useState} from 'react';
import './CustomChargerMarker.css';
import CustomChargerInfoCard from './CustomChargerInfoCard';
import { getNOCDashboardReducer } from '../../rmsReduxStore/reduxExports';
import { useAppSelector } from '../../globalUtils/globalExports';
import {MarkerIcons} from './CustomNocMarkerIcons';
import { Icon } from '../../globalUtils/globalIcons';



interface ICustomChargerMarkerProp {
  charger: IChargerDetails;
  handleMarkerClicked:(item:IChargerDetails)=>void;
  selectedCharger:string | null;
  showChargingIcon?: boolean | null; 
  clusterId?:string
}

const CustomChargerMarker: React.FC<ICustomChargerMarkerProp> = (props) => {
  const { charger,handleMarkerClicked,selectedCharger,showChargingIcon } = props
  const criticalCount = charger.alarms.critical;
  const majorCount = charger.alarms.major;
  const minorCount = charger.alarms.minor;
  const activeChargingSession = charger?.activeChargingSession1 || charger?.activeChargingSession2 || charger?.activeChargingSession3;
  const {nocDashboardLatestAlarmCharger} = useAppSelector(getNOCDashboardReducer)


  let markerIcon = showChargingIcon ? activeChargingSession ? MarkerIcons?.normalWithChargingActive : MarkerIcons?.normalWithChargingInactive : MarkerIcons?.normal

  if(criticalCount > 0) markerIcon = showChargingIcon ? activeChargingSession ? MarkerIcons?.criticalWithChargingActive : MarkerIcons?.crticalWithChargingInactive : MarkerIcons?.crticalStatic
  else if(majorCount > 0) markerIcon = showChargingIcon ? activeChargingSession ? MarkerIcons?.majorWithChargingActive : MarkerIcons?.majorWithChargingInactive : MarkerIcons?.majorStatic
  else if(minorCount > 0) markerIcon = showChargingIcon ? activeChargingSession ? MarkerIcons?.minorWithChargingActive : MarkerIcons?.minorWithChargingInactive : MarkerIcons?.minorStatic


  if(charger?.status?.toLowerCase() === 'offline')markerIcon = showChargingIcon ? MarkerIcons?.offlineWithChargingInactive :  MarkerIcons?.offline

  const animationClass = charger?.status === 'Online' && charger?.alarmSetAt && (((Date.now() - new Date(charger?.alarmSetAt?.replace('Z','')).getTime()) / 1000) <= 60*60*2 || nocDashboardLatestAlarmCharger?.name === charger?.name )? charger?.alarms?.critical ? 'critical-pulse' : charger?.alarms?.major ? 'major-pulse' : charger?.alarms?.minor ? 'minor-pulse' : '': '';


  return (
    <div className='noc-dashboard-marker-container'>
      <div className={'noc-dashboard-marker' + ` ${animationClass}`}
        onClick={()=>{
          handleMarkerClicked(charger)
        }
      }
      >
        <Icon iconClassName={markerIcon} />
      </div>
      
    </div>
  );
};

export default React.memo(CustomChargerMarker,(prevProp,nextProp)=>{
    const prevChargerId = prevProp?.charger?.id;
    const nextChargerId = nextProp?.charger?.id;
    const prevShowChargingIcon = prevProp?.showChargingIcon;
    const nextShowChargingIcon = nextProp?.showChargingIcon;

    return prevChargerId === nextChargerId && prevShowChargingIcon === nextShowChargingIcon;
});